import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { DEFAULT_THEME } from "../constants/theme";

const ThemeTooltip = ({ text, children, theme = DEFAULT_THEME }) => {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);

    const handleMouseEnter = () => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 8,
                left: rect.left + rect.width / 2
            });
            setVisible(true);
        }
    };

    return (
        <>
            <div
                ref={triggerRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={() => setVisible(false)}
                className="relative flex items-center"
            >
                {children}
            </div>
            {visible && createPortal(
                <div
                    className="fixed z-[99999] pointer-events-none"
                    style={{ top: position.top, left: position.left }}
                >
                    <div className={`relative -translate-x-1/2 ${theme.bg} backdrop-blur-md text-white text-xs font-bold px-3 py-2 rounded-xl shadow-xl border border-white/20 whitespace-nowrap`}>
                        {text}
                        <div className={`absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent ${theme.bg.replace("bg-", "border-b-")}`}></div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default ThemeTooltip;
